export default {
    HANDS_UP: '🙌',
    WINKING_EYES: '😜',
    RAINBOW: '🌈',
    GIRL:'👩🏽‍🦱',
    TURTLE:'🐢',
    CRYING_FACE: '😥',
    PARTY: '🎉',
}